/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_Plan_ActiveInputs */

const en_directory_submit_review_plan_active = /** @type {(inputs: Directory_Submit_Review_Plan_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active — submit with the Free review button, your plan benefits apply automatically`)
};

const zh_directory_submit_review_plan_active = /** @type {(inputs: Directory_Submit_Review_Plan_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已生效 — 点击免费审核按钮提交，套餐权益自动应用`)
};

/**
* | output |
* | --- |
* | "Active — submit with the Free review button, your plan benefits apply automatically" |
*
* @param {Directory_Submit_Review_Plan_ActiveInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_plan_active = /** @type {((inputs?: Directory_Submit_Review_Plan_ActiveInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Plan_ActiveInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_plan_active(inputs)
	return zh_directory_submit_review_plan_active(inputs)
});
export { directory_submit_review_plan_active as "directory.submit.review.plan_active" }